// removed by extract-text-webpack-plugin
module.exports = {"PostCodePopup":"postcode-popup__PostCodePopup___epoyF","First":"postcode-popup__First___1ZccN","Form":"postcode-popup__Form___1llQp","Input":"postcode-popup__Input___3CiC1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/postcode-popup/postcode-popup.less
// module id = 1284
// module chunks = 0 1